'use client'

import React, { createContext, ReactElement, ReactNode, useState } from 'react'

export const OpenCloseContext = createContext<
  { open: boolean; setOpen: (b: boolean) => void } | undefined
>(undefined)

export function OpenCloseProvider(props: { children: ReactNode, initialyOpen?: boolean }): ReactElement {
  const [open, setOpen] = useState(!!props.initialyOpen)

  return (
    <OpenCloseContext.Provider value={{ open, setOpen }}>
      {props.children}
    </OpenCloseContext.Provider>
  )
}
